import axios from "axios"

export const fetchPricingLoads = (filter) => {
  const options = {
    method: 'get',
    url: '/api/v2/load_pricing',
    params: filter
  }
  //TODO: add params in here from filter

  return axios(options)
}


export const fetchComparableLoad = (load) => {
  const options = {
    method: 'get',
    url: `/api/v2/load_pricing/${load.pro}/comparables`
  }
  //TODO: add params for filter if we want more than 30 days back

  return axios(options)
}

export const updateLoadPricing = (data) => {
  const options = {
    method: 'patch',
    url: `/api/v2/load_pricing/~`,
    data
  }
  //TODO: add params for filter if we want more than 30 days back

  return axios(options)
}
